/* tslint:disable */
/**
 */
export class TicketReprint {
    from_date?: string;
    to_date?: string;
    user_id?: number;
    limit?: number;
    page?: number;
    ticket_price_id?: number;
}
